import React, { useEffect, useRef, useState } from "react";
import { apiClient } from "../lib/api";
import { fmtNum } from "../lib/format";

const LABELS = {
  NIFTY50: "NIFTY 50",
  SENSEX: "SENSEX",
  NIFTY500: "NIFTY 500",
};

export default function BenchmarkStrip() {
  const [data, setData] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [pulse, setPulse] = useState(false);
  const intervalRef = useRef(null);

  const fetchOnce = async () => {
    try {
      const { data } = await apiClient.get("/prices/benchmarks");
      setData(data);
      setUpdatedAt(new Date());
      setPulse(true);
      setTimeout(() => setPulse(false), 800);
    } catch {
      /* silent */
    }
  };

  useEffect(() => {
    fetchOnce();
    intervalRef.current = setInterval(fetchOnce, 60_000);
    return () => clearInterval(intervalRef.current);
  }, []);

  if (!data) return null;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.24em] text-muted-foreground font-mono">
        <span className="inline-flex items-center gap-1.5">
          <span className={`h-1.5 w-1.5 rounded-full bg-lime ${pulse ? "" : "lime-pulse"}`} />
          Live · Yahoo Finance
        </span>
        <span>
          {updatedAt ? `${updatedAt.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}` : ""}
        </span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {Object.keys(LABELS).map((k) => {
          const v = data.quotes?.[k];
          return (
            <div key={k} className="card-noir p-3 sm:p-4 rounded-lg" data-testid={`bench-${k}`}>
              <div className="text-[9px] text-muted-foreground tracking-[0.28em] uppercase font-mono">{LABELS[k]}</div>
              <div className="text-base sm:text-xl font-mono font-semibold mt-1 tabular text-lime">
                {v != null ? fmtNum(v) : "—"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
